import { useEffect, useState } from "react";
import { HiClipboardList } from "react-icons/hi";

export default function Wishlist() {
  const [items, setItems] = useState([]);

  const API = process.env.REACT_APP_API_URL || "https://online-tech.in/api/";
  const API_BASE = API.replace(/api\/?$/, "");

  const user = JSON.parse(localStorage.getItem("medarphaUser") || "{}");
  const userId = user?.userId || 0;

  // ✅ Fetch wishlist items
  useEffect(() => {
    if (!userId) return;

    fetch(`${API}WishlistAPI/GetWishlistById?id=${userId}`, {
      method: "GET",
      headers: { accept: "*/*" },
    })
      .then((res) => res.json())
      .then((res) => {
        const list = res?.data || res || [];
        setItems(Array.isArray(list) ? list : []);
      })
      .catch((err) => console.warn("Wishlist fetch failed", err));
  }, [userId]);

  // ✅ Remove item handler (same InsertWishlist API toggles the wishlist)
  const handleRemove = async (productId, categoryId) => {
    if (!userId || !productId) return;

    try {
      const res = await fetch(`${API}WishlistAPI/InsertWishlist`, {
        method: "POST",
        headers: {
          accept: "*/*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: userId,
          productId: productId,
          categoryId: categoryId || 0,
        }),
      });

      const data = await res.json();

      if (data?.succeeded || data?.success) {
        // ✅ Remove from frontend state as well
        setItems((prev) =>
          prev.filter(
            (item) =>
              item.productId !== productId ||
              item.categoryId !== categoryId
          )
        );
      } else {
        console.error("Remove failed:", data);
      }
    } catch (err) {
      console.error("Remove wishlist error", err);
    }
  };

  return (
    <div>
      {/* Header */}
      <h5 className="fw-bold text-danger mb-3 d-flex align-items-center">
        <HiClipboardList size={24} className="me-2" />
        Saved For Later
      </h5>

      {items.length === 0 ? (
        <p className="text-muted">No items in wishlist.</p>
      ) : (
        <div className="row g-3">
          {items.map((item) => {
            const imageUrl = item.testImage
              ? `${API_BASE}TestMasterImage/${item.testImage}`
              : null;

            return (
              <div
                key={item.productId || item.id}
                className="col-12 col-md-6 col-lg-4"
              >
                <div
                  className="d-flex flex-column align-items-center border rounded p-3 h-100"
                  style={{ background: "#fff", minHeight: "150px" }}
                >
                  {/* Image or default icon */}
                  {imageUrl ? (
                    <img
                      src={imageUrl}
                      alt={item.testName}
                      style={{ width: "150px", height: "100px", objectFit: "cover" }}
                      className="rounded mb-2"
                      onError={(e) => (e.target.src = "")}
                    />
                  ) : (
                    <div
                      className="d-flex justify-content-center align-items-center mb-2 rounded bg-light"
                      style={{ width: "150px", height: "100px" }}
                    >
                      <HiClipboardList size={40} className="text-secondary" />
                    </div>
                  )}

                  {/* Text and date */}
                  <div className="text-center flex-grow-1 d-flex flex-column justify-content-between">
                    <p className="mb-1 fw-semibold">{item.testName}</p>
                    <small className="text-muted d-block">
                      Added On: {item.createdDate?.split("T")[0]}
                    </small>

                    {/* ✅ Remove button below the date */}
                    <button
                      className="btn btn-sm btn-danger mt-2"
                      onClick={() => handleRemove(item.productId, item.categoryId)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
